import React from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { createTheme } from '@mui/material/styles';
import { green, orange } from '@mui/material/colors';
import { LinkProps } from '@mui/material/Link';
import { isFProject } from 'config/project';
//import { ruRU as coreBgBG } from '@mui/material/locale';
//import { ruRU as gridRu } from '@mui/x-data-grid';


const LinkBehavior = React.forwardRef<
    HTMLAnchorElement,
    Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>((props, ref) => {
    const {href, ...other} = props;
    // Map href (MUI) -> to (react-router)
    return <RouterLink ref={ref} to={href} {...other} />;
});

const theme = createTheme(
    {
        palette: isFProject ?
            {
                primary: green,
                secondary: orange,
            } :
            {
                primary: {main: '#1976d2'},
            },
        components: {
            MuiLink: {
                defaultProps: {
                    component: LinkBehavior,
                } as LinkProps,
            },
            MuiButtonBase: {
                defaultProps: {
                    LinkComponent: LinkBehavior,
                },
            },
            MuiTextField: {
                defaultProps: {
                    variant: 'standard',
                    margin: 'dense',
                    size: 'small',
                },
            },
            MuiSelect: {
                defaultProps: {
                    variant: 'standard',
                },
            },
            MuiDialogContent: {
                styleOverrides: {
                    root: {
                        paddingTop: 0,
                    },
                },
            },
            MuiCardHeader: {
                styleOverrides: {
                    root: {
                        '& .MuiTypography-h5': {
                            fontSize: '1.2rem',
                        },
                    },
                },
            },
            MuiCardContent: {
                styleOverrides: {
                    root: {
                        '.MuiCardHeader-root + &': {
                            paddingTop: 0,
                        }
                    },
                },
            },
        },
    },
    //gridRu, // x-data-grid translations
    //coreBgBG, // core translations

);

export default theme;
